module.exports = __webpack_public_path__ + "img/welcome-box.38c7bdad.svg";